export default __webpack_public_path__ + "5bc53ca7a4007fdb12039bbe4990a7f1.png";